import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useForm } from "react-hook-form";
import MobileIcon from "../../components/Icons/MobileIcon";
import ErrorMessage from "../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { v4 as uuidv4 } from "uuid";
import EmailIcon from "../../components/Icons/EmailIcon";
import { toast } from "react-toastify";


function ForgetPassword() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("phone");
  const randomDeviceId = uuidv4();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    reset({ email: "", phone: "" });
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    let deviceId = "";
    if (localStorage.getItem("deviceId")) {
      deviceId = localStorage.getItem("deviceId");
    } else {
      deviceId = "2024_" + randomDeviceId;
    }
    localStorage.setItem("deviceId", deviceId);
    const fcmToken = localStorage.getItem("fcmToken");
    let submitData = {
      ...(selectedOption === "email" && { email: data?.email }),
      ...(selectedOption === "phone" && { phone: data?.phone }),
      deviceId: deviceId,
      deviceToken: fcmToken ? fcmToken : randomDeviceId.slice(0, 10),
    };

    // console.log("submitdata>>>>>>>", submitData);
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.forget_password;
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(RoutesLink?.verify_otp, { state: { data: submitData } });
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <div className="login-content bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7 col-xl-8 px-0">
              <div className="login-img-card">
                <img
                  src={"/assets/img/solar-bg22.jpg"}
                  alt="login-solar"
                />
              </div>
            </div>
            <div className="col-12 col-lg-5 col-xl-4 px-0">
              <div className="d-flex align-items-center justify-content-center h-100">
                {/* login card start here... */}
                <div className="card login-card shadow-none">
                  <div className="card-body">
                    <button
                      className="btn back-arrow bg-light mb-3 p-2"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      <BackArrowIcon />
                    </button>
                    <h1 className="title mb-4">Forget Password</h1>

                    {/* Radio Button Options */}
                    <div className="form-group mb-3">
                      <div className="d-flex gap-3">
                        <label
                          className="border border-1 rounded px-4"
                          role="button"
                        >
                          <input
                            type="radio"
                            value="phone"
                            checked={selectedOption === "phone"}
                            onChange={handleOptionChange}
                          />{" "}
                          Mobile
                        </label>
                        <label
                          className="border border-1 rounded px-4"
                          role="button"
                        >
                          <input
                            type="radio"
                            value="email"
                            checked={selectedOption === "email"}
                            onChange={handleOptionChange}
                            disabled
                          />{" "}
                          Email
                        </label>
                      </div>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                      {/* Conditionally Render Email or Phone Input */}
                      {selectedOption === "email" ? (
                        <div className="form-group mb-3">
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                          <div className="position-relative icon-input">
                            <input
                              type="text"
                              className="form-control"
                              id="email"
                              name="email"
                              placeholder="Enter Email"
                              {...register("email", {
                                required: "Please fill in your email",
                                pattern: {
                                  value:
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                                  message: "Invalid email address",
                                },
                                validate: (value) =>
                                  value === value.toLowerCase() ||
                                  "Email must be in lowercase",
                              })}
                            />
                            <EmailIcon />
                          </div>
                          <ErrorMessage message={errors?.email?.message} />
                        </div>
                      ) : (
                        <div className="form-group mb-3">
                          <label htmlFor="phone" className="form-label">
                            Mobile Number
                          </label>
                          <div className="position-relative icon-input">
                            <input
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              className="form-control"
                              id="phone"
                              name="phone"
                              placeholder="Enter Mobile Number"
                              {...register("phone", {
                                required: "Please enter mobile number",
                              })}
                            />
                            <MobileIcon />
                          </div>
                          <ErrorMessage message={errors?.phone?.message} />
                        </div>
                      )}

                      <button
                        disabled={isLoading}
                        type="submit"
                        className="btn btn-primary py-2 w-100"
                      >
                        {isLoading ? <Spinner /> : "Get OTP"}
                      </button>
                    </form>
                  </div>
                </div>
                {/* login card end here... */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetPassword;
